module.exports = __webpack_public_path__ + "img/summit-scene-1.d0de568b.jpg";